import React, { useState} from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "./SigninAndSignup.css";
import OtpInput from "react-otp-input";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet-async";
import NavbarLogo from "../../Assets/Logo";

const SignupPage = () => {
  const location = useLocation();
  const redirectPath = new URLSearchParams(location.search).get("redirect");
  const navigate = useNavigate();
  const [formdata, setformData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    source: "web_app",
  });
  const [accessToken, setAccessToken] = useState("");
  const [showOtpPage, setShowOtpPage] = useState(false);
  const [otp, setOtp] = useState("");

  const InputEvent = (event) => {
    // console.log(formdata)
    const { name, value } = event.target;
    setformData((preval) => ({
      ...preval,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const btn = document.getElementById("sign-up-btn");
    btn.classList.add("btn-click");
    setTimeout(() => {
      btn.classList.remove("btn-click");
    }, 300);
    event.preventDefault();

    const myPromise = fetch(process.env.REACT_APP_BACKEND_URL + `/signup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: formdata.username,
        email: formdata.email,
        password: formdata.password,
        confirmPassword: formdata.confirmPassword,
        source: "web_app",
        device: "web", // Always 'web' for web app, even when accessed from mobile browsers
      }),
    });

    toast
      .promise(
        myPromise.then(async (res) => {
          const data = await res.json();
          if (!res.ok) {
            // Special handling for 409 status code
            resetFormData();
            throw new Error(data.error || "Signup failed");
          }
          return data;
        }),
        {
          loading: "Sending Otp...",
          success: "Otp Sent!",
          error: (err) => err.message || "An error occurred during signup.",
        }
      )
      .then((data) => {
        console.log(data);
        // Handle success case
        setShowOtpPage(true);
        // setUserId(data.user_id);
        setAccessToken(data.access_token);
      })
      .catch(() => {
        // Handle failure case
        signupBtnFailedAnimation();
      });
  };

  const resetFormData = () => {
    setformData({
      username: "",
      email: "",
      password: "",
      confirmPassword: "",
    });
  };

  const signupBtnFailedAnimation = () => {
    const failed = document.getElementById("sign-up-btn");
    setTimeout(() => {
      failed.classList.add("shake-button");
    }, 500);
    setTimeout(() => {
      failed.classList.remove("shake-button");
    }, 1000);
  };

  const handleVerifyOtp = async () => {
    const btn = document.getElementById("verify-otp-btn");
    btn.classList.add("btn-click");
    setTimeout(() => {
      btn.classList.remove("btn-click");
    }, 300);

    // Validation: Check if OTP is empty
    if (!otp) {
      toast.error("Enter OTP to proceed");
      return;
    }

    console.log(otp);

    // Define the fetch promise
    const myPromise = fetch(
      `${process.env.REACT_APP_BACKEND_URL}/verify_otp_signup`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Attach access token for authorization
        },
        body: JSON.stringify({ ...formdata, otp: otp }),
      }
    );

    // Use toast.promise to handle loading, success, and error states
    toast
      .promise(
        myPromise.then(async (res) => {
          const data = await res.json();
          if (!res.ok) {
            setOtp("");
            throw new Error(data.error || "OTP verification failed");
          }
          return data;
        }),
        {
          loading: "Verifying OTP...",
          success: "OTP verified successfully!",
          error: (err) =>
            err.message || "An error occurred during OTP verification.",
        }
      )
      .then((data) => {
        if (redirectPath) {
          navigate(`/login?redirect=${redirectPath}`);
        } else {
          navigate("/login");
        }
      })
      .catch(() => {
        // Handle failure case
        const failedBtn = document.getElementById("verify-otp-btn");
        failedBtn.classList.add("shake-button"); // Add shake animation on failure
        setTimeout(() => {
          failedBtn.classList.remove("shake-button");
        }, 1000);
      })
      .finally(() => {
        setOtp("");
      });
  };

  const handleResendOTP = async (event) => {
    event.preventDefault();

    // Define the fetch promise
    const myPromise = fetch(`${process.env.REACT_APP_BACKEND_URL}/resend_otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // Attach access token for authorization
      },
      body: JSON.stringify(formdata),
    });

    // Use toast.promise for loading, success, and error states
    toast
      .promise(
        myPromise.then(async (res) => {
          const response = await res.json();
          if (!res.ok) {
            setOtp("");
            throw new Error(response.message || "Failed to resend OTP");
          }
          return response; // Return the response data
        }),
        {
          loading: "Resending OTP...",
          success: `OTP sent to ${formdata.email}`,
          error: (err) => err.message || "Failed to resend OTP.",
        }
      )
      .then(() => {
        // Handle success case
        setShowOtpPage(true); // Show the OTP page again
      })
      .catch(() => {
        // Handle error case
        signupBtnFailedAnimation(); // Run failed animation
      })
      .finally(() => {
        setOtp("");
      });
  };

  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const handlePaste = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    const pastedText = event.clipboardData.getData("text/plain").trim();

    const input = event.target;
    const inputType = input.type; // Store the original input type
    input.type = "text"; // Temporarily change input type to "text"
    console.log(name);
    var newValue = value.substring(0, input.selectionStart) + pastedText;
    if (name !== "email") {
      newValue = newValue + value.substring(input.selectionEnd);
    }
    setformData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));

    // Change input type back to the original type
    input.type = inputType;

    // // Trigger the onChange event to update the state
    const changeEvent = new Event("input", { bubbles: true });
    input.dispatchEvent(changeEvent);
  };


  const googleLogin = async (event) => {
    event.preventDefault(); // Prevent any default behavior
    try {
      // Redirect the user directly to the backend endpoint
      // console.log(process.env.REACT_APP_GOOGLE_URL);
      window.location.href = `${process.env.REACT_APP_GOOGLE_URL}`;
    } catch (error) {
      console.error("Error during Google login initiation:", error);
      alert("An error occurred while trying to log in with Google.");
    }
  };




  return (
    <>
      <Helmet>
        <title>
          Account Signup - Create An Account - IzzyAI
        </title>
        <meta name="description"
          content="New to IzzyAI? Quickly Sign Up for an account now and start discovering IzzyAI.com website."
        />
      </Helmet>
      <div
        className="outer-box pt-[80px] dark:bg-[#101920] flex flex-col justify-center items-center "
        id="signup-page"
      >
        <div className="inner-box mx-auto my-auto">
          {showOtpPage ? (
            <>
              <div className="container">
                <div className="row justify-content-md-center">
                  <div className="col-md-4 text-center">
                    <div className="row">
                      <div className="col-sm-12 mt-5 bgWhite otp-section">
                        <div className="flex items-center justify-center mb-6">
                          <NavbarLogo />
                        </div>
                        <h2 className="text-center text-xl font-bold mb-4 dark:text-white">Verify OTP</h2>
                        <p className="text-center text-gray-600 dark:text-gray-200 mb-6">We've sent an OTP to {formdata.email}. Please enter it below.</p>

                        <OtpInput
                          value={otp}
                          onChange={setOtp}
                          numInputs={6}
                          containerStyle={{ justifyContent: "center" }}
                          renderInput={(props, index) => (
                            <input
                              {...props}
                              style={{
                                display: "inline-block",
                                width: "50px",
                                height: "50px",
                                textAlign: "center",
                                border: "1px solid black",
                                borderRadius: "4px",
                                marginRight: "5px",
                              }}
                              className=" focus:outline-none"
                            />
                          )}
                          placeholder="000000"
                          onPaste={handlePaste}
                        />
                        <hr className="mt-5 mb-2" />
                        <div className="flex justify-center">
                          <input
                            type="submit"
                            id="verify-otp-btn"
                            value="Verify"
                            onClick={handleVerifyOtp}
                            className="create-account button  focus:outline-none inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow h-9 px-4 w-full mt-6 rounded-full  bg-black text-white hover:bg-gray-800"
                          />
                        </div>
                        <footer className="signup-footer footer-in-singup">
                          <p className="text-md text-gray-500 dark:text-gray-400">Already have an account?
                            <NavLink to="/login" className="marginDown hover:underline ml-2 text-blue-500">
                              Sign In
                            </NavLink>
                          </p>
                          <p className="text-md text-gray-500 dark:text-gray-400">Didn't receive OTP?
                            <NavLink to="/login" className="marginDown hover:underline ml-2 text-blue-500"
                              onClick={handleResendOTP}>
                              Resend OTP
                            </NavLink>
                          </p>
                        </footer>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <header className="signup-header mb-5">
                <div className="flex items-center justify-center mb-6">
                  <NavbarLogo />
                </div>
              </header>
              <h2 className="text-center text-xl font-bold mb-4 dark:text-white">Sign Up</h2>
              <p className="text-center text-gray-600 mb-6 dark:text-gray-200">Sign up to get started with IzzyAI</p>
              <div className="bg-gradient-to-r from-cyan-50 to-teal-50 border border-cyan-200 rounded-lg p-4 mb-6 dark:bg-gradient-to-r dark:from-[#1B2731] dark:to-[#24303A] dark:border-[#283642]">
                <p className="text-sm text-gray-900 dark:text-white mb-2">
                  <strong>Welcome to IzzyAI Beta Program!</strong>
                </p>
                <p className="text-sm text-gray-700 dark:text-gray-200">
                  After verifying your email, you'll need to add your payment details. Your card will be saved securely, but <strong className="dark:text-white">you won't be charged during the beta period</strong>.
                </p>
              </div>
              <main className="signup-body">
                <form onSubmit={handleSubmit} className="form">
                  <div className="mb-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300" htmlFor="username">
                      Username <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      className="dark:text-white flex h-9 rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 w-full"
                      id="username"
                      name="username"
                      value={formdata.username}
                      onChange={InputEvent}
                      placeholder="Enter your username"
                      required
                      onPaste={handlePaste}
                    />
                  </div>
                  <div className="mb-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300" htmlFor="email">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      className="dark:text-white flex h-9 rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 w-full"
                      id="email"
                      name="email"
                      title="Enter a valid email address"
                      value={formdata.email}
                      onChange={InputEvent}
                      onPaste={handlePaste}
                      placeholder="Enter your email"
                      required=""
                    />
                  </div>

                  <div className="mb-1">
                    <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300" htmlFor="password">Password <span className="text-red-500">*</span></label>
                    <div className="relative">
                      <input
                        type={`${showPassword1 ? "text" : "password"}`}
                        className="dark:text-white flex h-9 rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 w-full pr-10"
                        id="password"
                        name="password"
                        placeholder="Enter your password here."
                        required value={formdata.password}
                        onChange={InputEvent}
                        onPaste={handlePaste}
                      />
                      <button type="button" className="absolute inset-y-0 right-0 px-3 flex items-center justify-end md:w-12 w-10" style={{ backgroundColor: "transparent" }}>
                        {
                          showPassword1 ? <svg onClick={() => setShowPassword1(!showPassword1)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="lucide lucide-eye h-5 w-5 text-gray-500 hover:text-gray-700 dark:text-gray-200 dark:hover:text-gray-300"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
                            : <svg onClick={() => setShowPassword1(!showPassword1)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="lucide lucide-eye-off h-5 w-5 text-gray-500 hover:text-gray-700 dark:text-gray-200 dark:hover:text-gray-300"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"></path><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"></path><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"></path><path d="m2 2 20 20"></path></svg>
                        }

                      </button>
                    </div>
                  </div>
                  <div className="mb-1">
                    <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300"htmlFor="password">Re-enter Password <span className="text-red-500">*</span></label>
                    <div className="relative">
                      <input
                        type={`${showPassword2 ? "text" : "password"}`}
                        className="dark:text-white flex h-9 rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 w-full pr-10"
                        id="check-password"
                        name="confirmPassword"
                        placeholder="Re-enter your password"
                        required value={formdata.confirmPassword}
                        onChange={InputEvent}
                        onPaste={handlePaste}
                      />
                      <button type="button" className="absolute inset-y-0 right-0 px-3 flex items-center justify-end md:w-12 w-10" style={{ backgroundColor: "transparent" }}>
                        {
                          showPassword2 ? <svg onClick={() => setShowPassword2(!showPassword2)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="lucide lucide-eye h-5 w-5 text-gray-500 hover:text-gray-700 dark:text-gray-200 dark:hover:text-gray-300"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
                            : <svg onClick={() => setShowPassword2(!showPassword2)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="lucide lucide-eye-off h-5 w-5 text-gray-500 hover:text-gray-700 dark:text-gray-200 dark:hover:text-gray-300"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"></path><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"></path><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"></path><path d="m2 2 20 20"></path></svg>
                        }
                      </button>
                    </div>
                  </div>
                  <div className="mb-3">
                    {formdata.password !== formdata.confirmPassword && (
                      <span className="text-red-500 text-[14px]">
                        *Passwords do not match
                      </span>
                    )}
                  </div>
                  <div className="flex justify-center">
                    <input
                      type="submit"
                      id="sign-up-btn"
                      value="Sign Up"
                      className="create-account button  focus:outline-none inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow h-9 px-4 w-full mt-6 rounded-full  bg-black text-white hover:bg-gray-800"
                    />
                  </div>
                </form>
              </main>
              <div className="mt-6 flex justify-center space-x-4">
                <button className="dark:bg-[#101920] inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 text-primary-foreground shadow w-36 h-12 p-0 rounded-full border border-gray-300 bg-white hover:bg-gray-200"
                  onClick={googleLogin}
                >
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALDSURBVHgBrVZNaBNREJ55bxOqF+MfHlTcongSWbVKwYLbFm8e+uNFPDQ9F2x7keLFFhR6s72KUHuqBcHm5MUmC14qSI0Hb0IXsfQimoqlMdn3xtmNG5ufbRObDzYzzMx735s3894LQgMg2054ABYKYRKA/+UEoquVcuOOk91rPO7mLNq2jVI+ZNXiLxER5vIkMwWlUgccx22YZNu2zZiUc6za0DhcIJoy0unne5IUbNsSUmYgeuW7QhONx9PpmZ020UoCzsRVWi9Vm41Q8bdISvmK6hEQ5QDRYZlimSuZyOIVDhGiGRIUte6uV5fydnm9vX4NklALp6jUcFRRCz09Y0w2GkVQJtl+Dabx7twavj1T4dQA8/Hl5STsE0FNYnFu0y5ujsFPAIfyJQ+n3wqCMgnQ31Y9/w3o7seQaApaBKQMJDxl/Kgw5g3XuJVvrzfg6oOvltQ4Cg2iLV8YNzzPsKpPC7V5btQgqYm7D5PQILZisVlRz4GALrQIUlJCEHm5aociOgwthFAKakgEwg1oEZTCXFANb1muEaHp6xvqIDz6dQlWC8e739956UAT6JxYX2Nh7rStTJ/EoCaaMOXL1eJRGPl5neUxToeeQBO4dv9LXzUBt5Dj/wYkSLC0uH0WRja7gkxKfrA6FgcaIuqc2DCFkPVi58sksZueM7N1wakJIRy78mJwzlroMyEC1tPH/KDpTG0W/L5A0QmSKAfzRAbKD1DnFuYgl+8xB1ClUJcaRYMw+QkeYtXGwhEQn++BL/9BT61Mn56sIPHRsXDbDu6A/0BAtD4AuHkR/FqsTJ/qDn0Vh9HvJtLQz2oOmgTFv4Nqfwb6xJtsW77YX7GAegP8rZMoMnzyTWiGSMOs+q0ms8NLuT1JQlxeGEiG+x45MWeNyPXSOBt1rnYlCRFkRtJCJCu0afL/e4msl/ey1Suvxh/mzRvnpE22rAAAAABJRU5ErkJggg==" alt="Google Icon" className="h-6 w-6" />
                </button>
                {/* <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 text-primary-foreground shadow w-36 h-12 p-0 rounded-full border border-gray-300 bg-white hover:bg-gray-200">
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGVSURBVHgB1ZUxUgIxFIb/LM64OBavRKuUdmpnJ0fAzls4nkA4gXAC8QZ4AvcI3MBnI1QYG2cr48sOOCwku8NGC/8ZhpCXx5e8vLzXQoSINKVE1+kecZ6bPLQuQUPRkb5RbbwohYe6tY0gdKzvFDB0Q/lMjWHzqxDqaK0s+qvf1mJU57P7SRR6P0OLgZnzuM6lVWVcXmwnbZPOP83czaWHdCJfLjy3NsdE7Bdip5Xdv6/AnycHuJdQuF3Tcppl8eTL4ilJcCm2rsx119xYkmC8eONBLaSIucKzDDWaafo+4/P1ia07iQTAAo+bcyWI5H4vBlAkwoyHlRCUY7yreDHnvs+wCTlFU1lwyNS4rGwxFD7w1xBVEYUyxOIVzaUl/bv1ECBDhFxFdu+sGpJigjgVD3n5FPwQw2xs5GkcSMJOQUgheVCIE29W5i2ILMjkNLU9IiTr2aQ/hfeLpjTFjpI0Hvn6iwo5eKuxvOrizhRIHM/WbXKCDDmufK04CClAWpM4ropm5kJZsrsssgJT0udnHJuZ/0DfO2eB+H4HNIUAAAAASUVORK5CYII=" alt="Apple Icon" className="h-6 w-6" />
                      </button> */}
              </div>
              <div className="mt-4 text-center">
                <p className="text-sm text-gray-500 dark:text-gray-400">Already have an account?
                  {
                    redirectPath != null ?
                      <NavLink to={`/login?redirect=${redirectPath}`} className="marginDown hover:underline ml-2 text-blue-500">
                        Sign In
                      </NavLink>
                      :
                      <NavLink to="/login" className="marginDown hover:underline ml-2 text-blue-500">
                        Sign In
                      </NavLink>
                  }
                </p>
              </div>
            </>
          )}
        </div>
        <p className="pt-5 dark:text-white font-bold">*Patent Pending</p>
      </div>

    </>
  );
};
export default SignupPage;
